import { Component, inject, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe } from "@ngx-translate/core";

import { Constants } from "../../../constants/constants";
import { TableSelectedRow, UserEntitiesResponsibleFor } from "../../../models";
import { DataTableComponent } from "../../table/data-table/data-table";

@Component({
  selector: "adaa-user-responsiblities-modal",
  imports: [TranslatePipe, DataTableComponent],
  templateUrl: "./user-responsiblities-modal.html",
  styleUrl: "./user-responsiblities-modal.scss",
})
export class UserResponsiblitiesModalComponent {
  modal: NgbActiveModal = inject(NgbActiveModal);
  readonly Constants = Constants;

  @Input() selectedResponsiblities: UserEntitiesResponsibleFor[];
  @Input() entities: UserEntitiesResponsibleFor[];
  @Input() idProp: string;

  rowSelected: TableSelectedRow;

  public save(): void {
    this.modal.close(this.rowSelected?.allSelectedRows);
  }
}
